import NotificationsList from './container';
export default NotificationsList;
